import { useAtomValue } from "jotai";
import { isTokenValid } from "../../../legacy/services/authentication-service/auth-state/is-token-valid";
import { accessTokenAtom } from "../../../legacy/services/authentication-service/stores/access-token/access-token.store";

export function useIsLogged() {
  const accessToken = useAtomValue(accessTokenAtom);
  return isTokenValid(accessToken);
}
